import { acceptHMRUpdate, defineStore } from 'pinia'

import { STATUS } from '@/lib/utils/statuses'

export const useRolesStore = defineStore('roles', {
  state: () => ({
    bioVTAdmin: false,
    companyAdmin: false,
    departmentMember: false,
  }),

  getters: {
    hasAtLeastOneRole: (state) => state.companyAdmin || state.bioVTAdmin || state.departmentMember,
    isUserSuperAdmin: (state) => state.bioVTAdmin,
    isUserAdmin: (state) => state.bioVTAdmin || state.companyAdmin,
  },

  actions: {
    setRoles({ itsSuperAdmin, itsRole }) {
      this.$reset()
      const roles = {
        bioVTAdmin: itsSuperAdmin,
        companyAdmin: itsRole === STATUS.COMPANY_ADMIN,
        departmentMember: itsRole === STATUS.DEPARTMENT_MEMBER,
      }
      Object.assign(this, roles)
    },

    resetRoles() {
      this.$reset()
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useRolesStore, import.meta.hot))
}
